import styled, { Color, BorderRadius } from '@nfinite/react-hubstairs/styled'
import ImageComponent from 'components/Commons/Image'

export const PictureContainer = styled('div')`
  height: 160px;
  width: 160px;
  ${BorderRadius.generateForImage('round')}
  overflow: hidden;
  background-color: ${Color.get('background')};
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`

export const Image = styled(ImageComponent)`
  height: 100%;
  width: 100%;
`
export const Overlay = styled('div')`
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
`
